// The prize-draw wallet page, linked from the bottom nav, the desktop balance pill and the
// profile drawer, and used as its own payment return URL.
export const getWalletPath = (companyDomain: string) => `/${companyDomain}/prize-draw/wallet`
